"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MunicipalitiesMAPC = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var React = _interopRequireWildcard(require("react"));

var _Source = require("./Source");

var _Layer = require("./Layer");

var MunicipalitiesMAPC = function MunicipalitiesMAPC(_ref) {
  var type = _ref.type,
      layerId = _ref.layerId,
      paint = _ref.paint,
      data = _ref.data,
      colorScale = _ref.colorScale,
      choroplethFunc = _ref.choroplethFunc,
      matchOn = _ref.matchOn,
      mapColumn = _ref.mapColumn;

  var _React$useState = React.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      choropleth = _React$useState2[0],
      setChoropleth = _React$useState2[1];

  React.useEffect(function () {
    if (data) {
      var choroplethTemp = ['match', ['get', 'municipal']];
      data.forEach(function (row) {
        choroplethTemp.push(row[matchOn], row[mapColumn] ? choroplethFunc(colorScale, row[mapColumn]) : 'gray');
      });
      choroplethTemp.push('gray');
      setChoropleth(choroplethTemp);
    }
  }, [choroplethFunc, colorScale, data, mapColumn, matchOn]);
  return /*#__PURE__*/React.createElement(_Source.Source, {
    sourceId: "MAPC Municipalities",
    url: "ihill.763lks2o"
  }, /*#__PURE__*/React.createElement(_Layer.Layer, {
    type: type,
    paint: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, paint), {}, {
      'fill-color': choropleth
    }),
    sourceLayer: "MAPC_borders-0im3ea",
    layerId: layerId
  }));
};

exports.MunicipalitiesMAPC = MunicipalitiesMAPC;